const combiMedication: Map<string, number> = new Map();
combiMedication.set("atc", 2);

combiMedication.set("C07BB02",2)
combiMedication.set("C07BB22",2)
combiMedication.set("C07BB52",2)
combiMedication.set("C07CB02",2)
combiMedication.set("C07CB22",2)
combiMedication.set("C07FB02",2)
combiMedication.set("C07FB13",2)
combiMedication.set("C07FB22",2)
combiMedication.set("C07FX03",2)
combiMedication.set("C07FX05",2)
combiMedication.set("C07BA05",2)
combiMedication.set("C07CA05",2)
combiMedication.set("C07DA25",3)
combiMedication.set("C07EA05",2)
combiMedication.set("C07FX01",2)
combiMedication.set("C09BB",2)
combiMedication.set("C09BA",2)
combiMedication.set("C09XA53",2)
combiMedication.set("C09XA52",2)
combiMedication.set("C09XA54",3)
combiMedication.set("C07CG",2)
combiMedication.set("C07BG",2)
combiMedication.set("C08GA02",2)
combiMedication.set("C09DB",2)
combiMedication.set("C09DA",2)
combiMedication.set("C07FX18",3)
combiMedication.set("C07FB",2)
combiMedication.set("C07E",2)
combiMedication.set("C07CA",2)
combiMedication.set("C07BA",2)
combiMedication.set("C07CB",2)
combiMedication.set("C07BB",2)
combiMedication.set("C07D",3)
combiMedication.set("C07FX04",2)
combiMedication.set("C07FX17",2)
combiMedication.set("C07FX19",2)
combiMedication.set("C09DX06",3)
combiMedication.set("C07FX06",2)
combiMedication.set("C02LC01",2)
combiMedication.set("C02LC51",3)
combiMedication.set("C03E",2)
combiMedication.set("C09DX07",3)
combiMedication.set("C02LB01",2)
combiMedication.set("C07FX16",2)
combiMedication.set("C02LC05",2)
combiMedication.set("C08GA01",2)
combiMedication.set("C09DX03",3)
combiMedication.set("C07FX15",2)
combiMedication.set("C09BX02",2)
combiMedication.set("C09BX01",3)
combiMedication.set("C09BX04",3)
combiMedication.set("C09BX06",4)
combiMedication.set("C02LE01",2)
combiMedication.set("C09BX05",2)
combiMedication.set("C09BX03",3)
combiMedication.set("C02LA01",2)
combiMedication.set("C02LA51",3)
combiMedication.set("C02LA71",3)
combiMedication.set("C07FX02",2)
combiMedication.set("C03BB",2)
combiMedication.set("C09DX08",3)
combiMedication.set("C03AB",2)
combiMedication.set("C03AX",2)
combiMedication.set("C03AH",3)
combiMedication.set("C09DX02",2)
combiMedication.set("C09DX05",2)
combiMedication.set("C09DX04",2)
combiMedication.set("C09DX01",3)
combiMedication.set("C08GA23",2)
combiMedication.set("C08GA53",3)
combiMedication.set("N05AH53",2)
combiMedication.set("A02AG02",2)
combiMedication.set("A02BA51",2)
combiMedication.set("A03CA34",2)
combiMedication.set("A03CB01",2)
combiMedication.set("A03CB02",2)
combiMedication.set("A03CB03",2)
combiMedication.set("A03CB04",2)
combiMedication.set("A03CB38",2)
combiMedication.set("A03DA06",2)
combiMedication.set("A03DB04",2)
combiMedication.set("A03EA02",2)
combiMedication.set("A03EA04",2)
combiMedication.set("A04AB52",2)
combiMedication.set("A04AB54",2)
combiMedication.set("A04AB55",2)
combiMedication.set("A04AB58",2)
combiMedication.set("A04AD51",2)
combiMedication.set("A08AA62",2)
combiMedication.set("A15AA51",2)
combiMedication.set("C03BK",2)
combiMedication.set("D04AA82",2)
combiMedication.set("G04BD59",2)
combiMedication.set("G04BD69",2)
combiMedication.set("G04BD71",2)
combiMedication.set("G04CA53",2)
combiMedication.set("H02B",2)
combiMedication.set("M01AE57",2)
combiMedication.set("M03BA52",2)
combiMedication.set("M03BA72",2)
combiMedication.set("M03BC51",2)
combiMedication.set("M03BX53",2)
combiMedication.set("N05BB51",2)
combiMedication.set("N05CB",2)
combiMedication.set("N05CX07",2)
combiMedication.set("N05CX13",2)
combiMedication.set("N07CA22",2)
combiMedication.set("R05DA56",2)
combiMedication.set("R06AA52",2)
combiMedication.set("R06AA54",2)
combiMedication.set("R06AA61",2)
combiMedication.set("R06AB51",2)
combiMedication.set("R06AB54",2)
combiMedication.set("R06AB56",2)
combiMedication.set("R06AD52",2)
combiMedication.set("R06AD55",2)
combiMedication.set("R06AE55",2)
combiMedication.set("S01FA51",2)
combiMedication.set("V03AB05",2)
combiMedication.set("V03AB54",2)
combiMedication.set("N01AH51",2)
combiMedication.set("N02AC52",2)
combiMedication.set("N02CX69",2)
combiMedication.set("A03FA51",2)
combiMedication.set("N02AJ15",2)
combiMedication.set("N02AJ16",2)
combiMedication.set("N02AJ14",2)
combiMedication.set("N02AJ13",2)
combiMedication.set("N06CA03",2)
combiMedication.set("N06CA01",2)
combiMedication.set("N06CA06",2)
combiMedication.set("N06CA02",2)
combiMedication.set("N06CA10",2)
combiMedication.set("C10BX01",2)
combiMedication.set("C10BX02",2)
combiMedication.set("C10BX04",3)
combiMedication.set("C10BX05",2)
combiMedication.set("C10BX06",3)
combiMedication.set("C10BX08",2)
combiMedication.set("C10BX12",3)
combiMedication.set("M01AB51",2)
combiMedication.set("M01AB55",2)
combiMedication.set("M01AB68",2)
combiMedication.set("M01AB69",2)
combiMedication.set("M01AX55",2)
combiMedication.set("M01AX68",2)
combiMedication.set("M01BA01",2)
combiMedication.set("M01BA03",2)
combiMedication.set("M01BA04",2)
combiMedication.set("N02AJ02",2)
combiMedication.set("N02AJ05",2)
combiMedication.set("N02AJ07",2)
combiMedication.set("N02AJ08",2)
combiMedication.set("N02AJ18",2)
combiMedication.set("N02AJ19",2)
combiMedication.set("N02AJ23",2)
combiMedication.set("N02BA51",2)
combiMedication.set("N02BA71",2)
combiMedication.set("R05XA02",2)
combiMedication.set("R05XA22",2)
combiMedication.set("B01AC34",2)
combiMedication.set("B01AC36",2)
combiMedication.set("B01AF51",2)
combiMedication.set("C07B",2)
combiMedication.set("C07C",2)
combiMedication.set("C07CA51",2)
combiMedication.set("C07CA52",2)
combiMedication.set("C07CB23",2)
combiMedication.set("C10BX13",3)
combiMedication.set("H01BA",2)
combiMedication.set("A02BA53",2)
combiMedication.set("A02BC51",2)
combiMedication.set("A02BC53",2)
combiMedication.set("A02BC54",2)
combiMedication.set("A02BD01",3)
combiMedication.set("A02BD02",3)
combiMedication.set("A02BD03",3)
combiMedication.set("A02BD04",3)
combiMedication.set("A02BD05",3)
combiMedication.set("A02BD06",3)
combiMedication.set("A02BD07",3)
combiMedication.set("A02BD08",3)
combiMedication.set("A02BD09",3)
combiMedication.set("A02BD10",3)
combiMedication.set("A02BD11",4)
combiMedication.set("A02BD12",3)
combiMedication.set("A02BD13",3)
combiMedication.set("A02BD14",3)
combiMedication.set("A02BD15",3)
combiMedication.set("A02BD16",3)
combiMedication.set("A02BD17",2)
combiMedication.set("A02BX50",2)
combiMedication.set("A02BX51",2)
combiMedication.set("A02BX62",2)
combiMedication.set("A02BX63",2)
combiMedication.set("A02BX70",2)
combiMedication.set("A02BX71",2)
combiMedication.set("A02BX77",2)
combiMedication.set("C02LB",2)
combiMedication.set("C02LC",2)
combiMedication.set("C02LE",2)
combiMedication.set("C02LF",2)
combiMedication.set("C02LG",2)
combiMedication.set("C02LK",2)
combiMedication.set("C02LL",2)
combiMedication.set("C02LN",2)
combiMedication.set("C02LX",2)
combiMedication.set("C02LA02",2)
combiMedication.set("C02LA03",2)
combiMedication.set("C02LA04",2)
combiMedication.set("C02LA07",2)
combiMedication.set("C02LA08",2)
combiMedication.set("C02LA09",2)
combiMedication.set("C02LA50",3)
combiMedication.set("C02LA52",2)
combiMedication.set("C02LA58",2)
combiMedication.set("C08GA22",2)

export {combiMedication as CombiMedication}